import { Controller } from "stimulus"
import QrCodeWithLogo from "qrcode-with-logos";
import glosepus from "../../icons/glosepus.png"

export default class extends Controller {
  static targets = ["canvas"]
  
  connect() {
    if (JSON.parse(localStorage.getItem('wordList')) == null) {
      return
    }
    window.addEventListener("updateQRCode", e => {
      this.makeQRCode(e.detail.urlValue)
    })
    let string = window.location.origin + window.location.pathname.replace("/share.html", "") + this.makeUrlParams()
    this.makeQRCode(string)
  }

  makeUrlParams() {
    let wordList = JSON.parse(localStorage.getItem('wordList'))
    let params = new URLSearchParams()

    Object.keys(wordList).forEach(element => {
      params.set(element, wordList[element])
    });

    return "?" + params.toString()
  }

  makeQRCode(urlValue) {
    new QrCodeWithLogo({
      canvas: this.canvasTarget,
      content: urlValue,
      width: 180,
      nodeQrCodeOptions: {
        color: {
          dark: "#000000",
        },
        errorCorrectionLevel: "M"
      },
      logo: {
        src: glosepus,
        logoSize: 0.15,
      }
    }).toImage();
  }
}